import { useContext, useEffect, useMemo, useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import BeneficiosCard from "../components/general/BeneficiosCard"
import Footer from "../components/general/footer"
import NavBar from "../components/general/NavBar"
import { getBeneficios, registrarAfiliado } from "../services/beneficiosService"
import "../styles/Beneficios.css"
import { ArrowRight } from "react-bootstrap-icons"
import CustomSpinner from "../components/general/CustomSpinner"
import UserContext from "../components/user/UserContext"

const CATEGORIAS = ["Todos", "Salud", "Hogar", "Educación", "Comercio", "Bienestar", "Programas", "Otros"]

const Beneficios = () => {

    const [beneficios, setBeneficios] = useState([])
    const [error, setError] = useState(false)
    const [categoriaActiva, setCategoriaActiva] = useState("Todos")
    const [vistaActiva, setVistaActiva] = useState("beneficios")
    const [afiliacion, setAfiliacion] = useState({ nombre: "", telefono: "", colonia: "", codigoPostal: "" })
    const [folio, setFolio] = useState("")
    const [errorFormulario, setErrorFormulario] = useState(false)
    const [guardandoAfiliado, setGuardandoAfiliado] = useState(false)

    const { loading, setLoading } = useContext(UserContext)

    useEffect(() => {
        const cargarBeneficios = async () => {
            try {
                setLoading(true)
                setBeneficios(await getBeneficios())
            } catch (error) {
                setError(true)
            } finally {
                setLoading(false)
            }
        }

        cargarBeneficios()
    }, [setBeneficios, setError, setLoading])

    const data = useMemo(() => categoriaActiva === "Todos"
        ? beneficios
        : beneficios.filter(item => item.categoria === categoriaActiva), [beneficios, categoriaActiva])

    const actualizarAfiliacion = ({ target }) => {
        setAfiliacion({ ...afiliacion, [target.name]: target.value })
    }

    const registrarAfiliacion = async event => {
        event.preventDefault()
        if (!afiliacion.nombre.trim() || !afiliacion.telefono.trim()) {
            setErrorFormulario(true)
            return
        }

        setErrorFormulario(false)
        setGuardandoAfiliado(true)

        try {
            setLoading(true)
            setFolio(await registrarAfiliado(afiliacion))
        } catch (error) {
            setErrorFormulario(true)
        } finally {
            setGuardandoAfiliado(false)
            setLoading(false)
        }
    }

    const enlaceWhatsApp = `https://wa.me/524433544335?text=${encodeURIComponent(
        `Hola, quiero afiliarme a la Red de Beneficios.\nNombre: ${afiliacion.nombre}\nWhatsApp: ${afiliacion.telefono}\nColonia: ${afiliacion.colonia}\nC.P.: ${afiliacion.codigoPostal}\nFolio: ${folio}`
    )}`

    return (
        <>
            {loading && <CustomSpinner />}
            <NavBar />
            <header className="beneficios-hero">

                <Container>

                    <p className="beneficios-kicker">RED DE BENEFICIOS</p>
                    <h1>Tu tarjeta abre esta red de beneficios</h1>
                    <p>Una tarjeta. Una comunidad. Muchos beneficios.</p>
                </Container>
            </header>
            <nav className="beneficios-tabs" aria-label="Secciones de beneficios">
                <button className={vistaActiva === "beneficios" ? "active" : ""} onClick={() => setVistaActiva("beneficios")}>Beneficios</button>
                <button className={vistaActiva === "afiliacion" ? "active" : ""} onClick={() => setVistaActiva("afiliacion")}>Únete gratis</button>
            </nav>
            <main>
                <Container className="beneficios-content">
                    {vistaActiva === "beneficios" ? <>
                        <div className="beneficios-intro">
                            <div><p className="beneficios-kicker">ALIADOS DE LA COMUNIDAD</p><h2>Beneficios para tu familia</h2></div>
                            <p className="beneficios-stat"><strong>{beneficios.length}</strong> negocios aliados<br />Directorio actualizado</p>
                        </div>
                        <div className="beneficios-filters" aria-label="Filtrar beneficios por categoría">
                            {CATEGORIAS.map(categoria => <button key={categoria} className={categoriaActiva === categoria ? "active" : ""} onClick={() => setCategoriaActiva(categoria)}>{categoria}</button>)}
                        </div>
                        {loading && <p className="text-center py-5">Cargando beneficios...</p>}
                        {!loading && error && <p className="text-center py-5 text-danger">No pudimos cargar los beneficios. Intenta nuevamente más tarde.</p>}
                        {!loading && !error && data.length === 0 && <p className="text-center py-5">No hay beneficios disponibles en esta categoría.</p>}
                        {!loading && !error && data.length > 0 && <Row xs={1} md={2} className="g-4">
                            {data.map(item => <Col key={item.id}><BeneficiosCard {...item} /></Col>)}
                        </Row>}
                        <a className="text-decoration-none beneficios-cta" href="https://wa.me/524433544335?text=Hola%2C%20quiero%20sumarme%20como%20Aliado%20a%20la%20Red%20de%20Beneficios%20de%20la%20Fundaci%C3%B3n%20Luis%20Altamirano." target="_blank" rel="noopener noreferrer" >
                            <div><h2>¿TIENES UN NEGOCIO?</h2><p>Súmate como Aliado — sin costo</p></div><span><ArrowRight /></span>
                        </a>
                    </> : <section className="afiliacion-panel">
                        {!folio ? <>
                            <div className="afiliacion-heading">
                                <p className="beneficios-kicker">AFILIACIÓN GRATUITA</p>
                                <h2>Únete a la red de beneficios</h2>
                                <p>Regístrate y recibe un folio para continuar tu proceso por WhatsApp.</p>
                            </div>
                            <form onSubmit={registrarAfiliacion}>
                                <div className="afiliacion-fields">
                                    <label>Nombre completo<input name="nombre" value={afiliacion.nombre} onChange={actualizarAfiliacion} placeholder="Tu nombre" /></label>
                                    <label>WhatsApp<input name="telefono" value={afiliacion.telefono} onChange={actualizarAfiliacion} placeholder="443 000 0000" type="tel" /></label>
                                    <label>Colonia<input name="colonia" value={afiliacion.colonia} onChange={actualizarAfiliacion} placeholder="¿Dónde vives?" /></label>
                                    <label>Código postal<input name="codigoPostal" value={afiliacion.codigoPostal} onChange={actualizarAfiliacion} placeholder="Ej. 60000" inputMode="numeric" maxLength="5" /></label>
                                </div>
                                {errorFormulario && <p className="afiliacion-error">No pudimos registrar tus datos. Revisa la información e inténtalo nuevamente.</p>}
                                <button className="afiliacion-submit" type="submit" disabled={guardandoAfiliado}>{guardandoAfiliado ? "Generando folio..." : <>Obtener mi tarjeta gratis <ArrowRight /></>}</button>
                                <p className="afiliacion-hint">Es gratis. Tus datos se usarán para continuar tu registro.</p>
                            </form>
                        </> : <div className="afiliacion-confirmacion">
                            <p className="beneficios-kicker">REGISTRO INICIADO</p>
                            <h2>Tu folio es <strong>{folio}</strong></h2>
                            <p>Guárdalo y envía tus datos por WhatsApp para continuar con la entrega de tu tarjeta.</p>
                            <a href={enlaceWhatsApp} target="_blank" rel="noopener noreferrer">Enviar mis datos por WhatsApp</a>
                            <button onClick={() => { setFolio(""); setAfiliacion({ nombre: "", telefono: "", colonia: "", codigoPostal: "" }) }}>Registrar a otra persona</button>
                        </div>}
                    </section>}
                </Container>
            </main>
            <Footer />
        </>
    )
}

export default Beneficios

